<app-form-select-single-v2
  placeholder="LNG_LAYOUT_LANGUAGE_LABEL"
  [(ngModel)]="selectedLanguageId"
  [options]="languageOptions"
  (ngModelChange)="selectLanguage()">
</app-form-select-single-v2>
